import React from 'react';
import Footer from '../components/Footer';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <section className="about-section">
        <div className="about-container">
          <h1 className="about-title">About Me</h1>
          <div className="about-content">
            <p>
              Welcome to my photography portfolio. I'm a passionate photographer
              dedicated to capturing the beauty of the world through my lens.
            </p>
            <p>
              My work focuses on landscapes, nature, and travel photography,
              bringing unique perspectives to every shot.
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default About;

